export default "__VITE_ASSET__DCXK9WyG__"